const ButtonBase = {
  defaultProps: {},
  styleOverrides: {
    root: () => ({
      minWidth: 0,
    }),
  },
};

export default ButtonBase;
